import './App.css';
import { Routes, Route } from 'react-router-dom';
import Index from './pages/Index';
import Contact from './pages/Contact';
// import Blogs from './pages/Blogs';
import AboutUs from './pages/AboutUs';
import Faqs from './pages/Faqs';
// import Rental from './pages/Rental';
// import Gallery from './pages/Gallery';
// import CaseStudies from './pages/CaseStudies';
import VrEngagements from './pages/VrEngagements';
import VirtualReality from './pages/VirtualReality';
import AugmentedReality from './pages/AugmentedReality';
// import Mytour from './pages/Mytour';
// import Pricing from './pages/Pricing';
// import RequestQuote from './pages/RequestQuote';
// import OtherServices from './pages/OtherServices';
// import DigiCenter from './pages/DigiCenter';
import VirtualTours from './pages/VirtualTours';
import FormSubmission from './pages/FormSubmission';
import DataProcessingPolicy from './components/dataprocessingpolicy';
import { HelmetProvider } from 'react-helmet-async';
import WebDevelopment from './pages/WebDevelopment';
// import Reference from './pages/reference';
import DigitalTransformation from './pages/DigitalTransformation';
import ManagedServices from './pages/ManagedServices';
import ProfessionalServices from './pages/ProfessionalServices';
import EnterpriseTechnologySolutions from './pages/EnterpriseTechnologySolutions';
import EducationTechnologySolutions from './pages/EducationTechnologySolutions';
import FinancialTechnologySolutions from './pages/FinancialTechnologySolutions';
import HealthcareSolutions from './pages/HealthcareSolutions';
import SystemIntegration from './pages/SystemIntegration';

function App() {
  return (
    <HelmetProvider>
      <>
        <Routes>
          <Route path='/' element={<Index />} />

          {/* SERVICES */}
          <Route path='/virtual-tours' element={<VirtualTours />} />
          <Route path='/vr-engagements' element={<VrEngagements />} />
          <Route path='/digital-transformation' element={<DigitalTransformation />} />
          <Route path='/managed-services' element={<ManagedServices />} />
          <Route path='/professional-services' element={<ProfessionalServices />} />

          {/* SOLUTIONS */}
          <Route path='/virtual-reality' element={<VirtualReality />} />
          <Route path='/augmented-reality' element={<AugmentedReality />} />
          <Route path='/web-development' element={<WebDevelopment />} />
          <Route path='/enterprise-technology-solutions' element={<EnterpriseTechnologySolutions />} />
          <Route path='/education-technology-solutions' element={<EducationTechnologySolutions />} />
          <Route path='/financial-technology-solutions' element={<FinancialTechnologySolutions />} />
          <Route path='/healthcare-solutions' element={<HealthcareSolutions />} />
          <Route path='/systems-integration' element={<SystemIntegration />} />

          {/* OTHER PAGES */}
          <Route path='/aboutus' element={<AboutUs />} />
          <Route path='/contactus' element={<Contact />} />
          <Route path='/formsubmission' element={<FormSubmission />} />

          {/* FOOTER */}
          <Route path='/faqs' element={<Faqs />} />
          <Route path='/data-processing-policy' element={<DataProcessingPolicy />} />
          {/* <Route path='/reference' element={<Reference />} /> */}

          {/* <Route path='/blogs' element={<Blogs />} /> */}
          {/* <Route path='/rentals' element={<Rental />} /> */}
          {/* <Route path='/case-studies' element={<CaseStudies />} />  */}
          {/* <Route path='/other-services' element={<OtherServices />} /> */}
          {/* <Route path='/tour' element={<Mytour />} /> */}
          {/* <Route path='/digi-center' element={<DigiCenter />} /> */}
          {/* <Route path='/pricing' element={<Pricing />} /> */}
          {/* <Route path='gallery' element={<Gallery />} /> */}
          {/* <Route path='/request-quote' element={<RequestQuote />} /> */}
          {/* <Route path='/x' element={<Contact />} />

          // FOR WEB APP MAINTAINANCE PURPOSE
        <Route path='/x' element={<Blogs />} />
        <Route path='/x' element={<AboutUs />} />
        <Route path='/x' element={<Faqs />} />
        <Route path='/x' element={<Rental />} />
        <Route path='/x' element={<CaseStudies />} />
        <Route path='/x' element={<VrEngagements />} />
        <Route path='/x' element={<Pricing />} />
        <Route path='x' element={<Gallery />} />
        <Route path='/x' element={<RequestQuote />} />
        <Route path='/x' element={<VirtualReality />} />
        <Route path='/x' element={<AugmentedReality />} />
        <Route path='/x' element={<OtherServices />} />
        <Route path='/tour' element={<Mytour />} />    */}
          {/* Error page */}
          <Route path="*" element={
            <div
              className='Error flex flex-col items-center justify-center text-center gap-8 w-full min-h-screen px-4 sm:px-16 md:px-32 lg:px-80 mx-auto'
              style={{
                backgroundImage: 'radial-gradient(gray 0px, transparent 1px)',
                backgroundSize: '20px 20px'
              }}
            >
              <div>
                <img src='../assets/404error.png' alt='404 error' className='w-16 h-16 mx-auto' />
              </div>
              <div className='text-3xl sm:text-4xl md:text-6xl font-semibold tracking-tighter capitalize'>
                <h2>oops 404 again! sorry, page not found.</h2>
              </div>
              <div className='font-roboto-mono'>
                <p className='-tracking-tighter lg:px-24 mx-auto'>Looks like nothing was found in this location. Check the url path entered or maybe try a search... </p>
              </div>
            </div>
          } />


          {/* SITE UNDER MAINTAINANCE */}
          {/* <Route path="*" element={
          <div
            className='Error flex flex-col items-center justify-center text-center gap-8 w-full min-h-screen px-4 sm:px-16 md:px-32 lg:px-80 mx-auto'
            style={{
              backgroundImage: 'radial-gradient(gray 0px, transparent 1px)',
              backgroundSize: '20px 20px'
            }}
          >
            <div>
              <img src='../assets/comingsoon.png' alt='404 error' className='w-16 h-16 mx-auto' />
            </div>
            <div className='text-3xl sm:text-4xl md:text-6xl font-semibold tracking-tighter capitalize'>
              <h2>oops! sorry, page not found.</h2>
            </div>
            <h4 className='mt-2 text-4xl'>We're coming soon!</h4>
            <div className='font-roboto-mono'>
              <p className='-tracking-tighter lg:px-24 mx-auto'>website is under development...  </p>
            </div>
          </div>
        } /> */}
        </Routes>
      </>
    </HelmetProvider>
  );
}

export default App;
